import { createReducer } from 'typesafe-actions'
import {RecommendationsData} from '../../entities/RecommendationsData'
import {resetVwnModelsWithRecommendationsData, setVwnModelsWithRecommendationsData} from '../actions/app/vwnRecommendation.actions'

export type VwnModelsWithRecommendationsDataState = RecommendationsData

export const defaultState: VwnModelsWithRecommendationsDataState = {
    carlines: [],
}

const vwnModelsWithRecommendationsDataReducer = createReducer(defaultState)
    .handleAction(setVwnModelsWithRecommendationsData, (state, action) => action.payload)
    .handleAction(resetVwnModelsWithRecommendationsData, () => defaultState)

export default vwnModelsWithRecommendationsDataReducer
